module.exports = __webpack_public_path__ + "img/in-icon.8c021d29.svg";